<template>
<div class="chapter">
<div class="inner_page">
<p class="copytit"><a id="page_4"></a>Credits</p>
<p class="copy">ISBN: 978-1-870067-73-7</p>
<p class="copy">Edited by Karel Margry. Designed by Winston Ramsey</p>
<p class="copy">First published in Great Britain in 2011 by After the Battle</p>
<p class="copy">Published in 2021 by After the Battle,</p>
<p class="copy">An imprint of Pen &amp; Sword Books Limited</p>
<p class="copy">Yorkshire – Philadelphia</p>
<p class="copy">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical including photocopying, recording or by any information storage and retrieval system, without permission from the Publisher in writing.</p>
<p class="copy">For a complete list of Pen &amp; Sword titles please contact</p>
<p class="copy">PEN &amp; SWORD BOOKS LIMITED</p>
<p class="copy">47 Church Street, Barnsley, South Yorkshire S70 2AS, UK</p>
<p class="copy">E-mail: <span class="weblink"><a href="mailto:enquiries@pen-and-sword.co.uk"><span class="underline">enquiries@pen-and-sword.co.uk</span></a></span></p>
<p class="copy">Website: <span class="weblink"><a href="http://www.pen-and-sword.co.uk" target="_blank"><span class="underline">www.pen-and-sword.co.uk</span></a></span></p>
<p class="copy">Or PEN AND SWORD BOOKS</p>
<p class="copy">1950 Lawrence Rd, Havertown, PA 19083,</p>
<p class="copy">USAE-mail: <span class="weblink"><a href="mailto:Uspen-and-sword@casematepublishers.com"><span class="underline">Uspen-and-sword@casematepublishers.com</span></a></span></p>
<p class="copy">Website: <span class="weblink"><a href="http://www.penandswordbooks.com" target="_blank"><span class="underline">www.penandswordbooks.com</span></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright.vue?575e9afc